<div *ngIf="ready"
     [ngModelGroup]="groupName"
     class="fieldsetsContainer">
  <div class="fieldsetsGroup">
    <datex-common-form-field-shell [label]="label"
                                   *ngIf="apiConnectionType">
      <ng-container *ngIf="!readOnly">
        <mat-select [(ngModel)]="apiConnectionName"
                    (ngModelChange)="apiConnectionNameChanged($event)"
                    name="apiConnectionName"
                    [disabled]="readOnly"
                    [required]="!readOnly"
                    class="datex-selectcontainer"
                    disableOptionCentering
                    panelClass="dropdown-below">
          <mat-option *ngFor="let apiConnection of apiConnections"
                      [value]="apiConnection.name"
                      class="datex-dropdownoption datex-dropdownpanel">
            {{apiConnection.name}}
            <ng-container *ngIf="apiConnection.readonly">(Readonly)</ng-container>
          </mat-option>
        </mat-select>
      </ng-container>
      <ng-container *ngIf="readOnly">
        <input [ngModel]="getReadOnlyApiConnection()"
               [readonly]="readOnly"
               class="datex-textbox readonly"
               name="apiConnectionName" />
      </ng-container>
    </datex-common-form-field-shell>
  </div>
</div>